/**
 * @deprecated This file is deprecated. Please use the shared version from '@starjack/features/notifications' instead.
 * This file will be removed in a future version.
 *
 * Example migration:
 *   Old: import { notificationSlice, notificationActions, NotificationState } from '@/slices/notificationSlice';
 *   New: import { notificationSlice, notificationActions, NotificationState } from '@starjack/features/notifications';
 */
import { SnackbarNotification } from '@/models/notification';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * @deprecated Use NotificationState from '@starjack/features/notifications' instead.
 */
export type NotificationState = {
    currentNotification: SnackbarNotification;
    next: SnackbarNotification[];
};

const initialState = {
    currentNotification: null,
    next: [],
};

/**
 * @deprecated Use notificationSlice from '@starjack/features/notifications' instead.
 */
export const notificationSlice = createSlice({
    name: 'notificationSlice',

    initialState,

    reducers: {
        addNotification(
            state: NotificationState,
            action: PayloadAction<SnackbarNotification>
        ) {
            const notification = action.payload;

            if (!state.currentNotification) {
                state.currentNotification = notification;
            } else {
                state.next.push(notification);
            }

            return state;
        },

        consumeNext(state: NotificationState) {
            state.currentNotification = state.next.shift();

            return state;
        },

        clearNotifications() {
            return initialState;
        },
    },
});

/**
 * @deprecated Use notificationActions from '@starjack/features/notifications' instead.
 */
export const notificationActions = {
    ...notificationSlice.actions,
};
